import React, { useEffect, useState } from "react";
import TwitterIcon from "../../images/Svg/dashboard/Twitter.svg";
import TiktokIcon from "../../images/Svg/Tiktok.svg";
import InstaragramIcon from "../../images/Svg/Instragram.svg";
import FacebookIcon from "../../images/Svg/dashboard/Facebook.svg";
import WordPressIcon from "../../images/Svg/dashboard/Wordpress.svg";
import { useDispatch, useSelector } from "react-redux";
import userIcon from "../../images/Svg/dashboard/user.jpg";
import LinkdeinIcon from "../../images/Svg/Linkdein.svg";
import {
  facebookLogin,
  facebookSignout,
  twitterLogin,
  twitterSignOut,
} from "../../reducers/auth/action";
import Spinner from "../../components/spinner/Spinner.component";
import DashboardCard from "../../components/Dashboard/DashboardCard.components";
import StepComponents from "../../components/Dashboard/Step.components";
import SecureLS from "secure-ls";
import {
  getInstagramApi,
  logoutInstagramApi,
  logoutWordpressApi,
} from "../../Network/network";
import { useRef } from "react";
import { Helmet } from "react-helmet";
import { ConfigContext } from "../../context/config";
import { useContext } from "react";
import useIdentity from "../../utils/identity";
import Iframe from "../../components/iframe/Iframe.component";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../utils/firebase";
import { pushGaEvent } from "../../utils/ga_events";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "s3cr3tPa$$w0raad@123",
});

export default function Dashboard() {
  const { twitter, facebook, deso } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const twitterLoginAction = () => dispatch(twitterLogin());
  const facebookLoginAction = () => dispatch(facebookLogin());
  const [instagram, setInstagram] = useState(null);
  const [facebookState, setFacebookState] = useState(null);
  const [twitterUserName, setTwitterUserName] = useState(null);
  const [wordpress, setWordpress] = useState(null);

  const { identityWindow } = useContext(ConfigContext);
  const { handleMessage } = useIdentity();

  useEffect(() => {
    window.addEventListener("message", (event) =>
      handleMessage(event, identityWindow)
    );
  }, [identityWindow]);

  // const instagramLogin = async () => {
  //   const popup = window.open(
  //     "https://web3setu.co.in/social-auth/login/instagram"
  //   );

  //   popup.opener.postMessage("hello there!", "http://web3setu.co.in");

  //   window.addEventListener(
  //     "message",
  //     (event) => {
  //       if (event.origin !== "https://web3setu.co.in") return;
  //       localStorage.setItem("instagram_info", JSON.stringify(event.data));
  //       setInstagram(event.data);
  //       return;
  //     },
  //     false
  //   );
  // };
  const wordpressLogin = async () => {
    pushGaEvent("WORDPRESS_CONNECT_BUTTON_CLICKED");
    const popup = window.open(
      "https://web3setu.co.in/social-auth/login/wordpress"
    );

    popup.opener.postMessage("hello there!", "http://web3setu.co.in");

    window.addEventListener(
      "message",
      (event) => {
        if (event.origin !== "https://web3setu.co.in") return;
        localStorage.setItem("wordpress_info", JSON.stringify(event.data));
        setWordpress(event.data);
        return;
      },
      false
    );
  };

  const wordpressLogout = async () => {
    pushGaEvent("WORDPRESS_LOGOUT_BUTTON_CLICKED");
    const res = await logoutWordpressApi();
    setWordpress(null);
    localStorage.removeItem("wordpress_info");
  };

  // const instagramLogout = async () => {
  //   const res = await logoutInstagramApi();
  //   setInstagram(null);
  //   localStorage.removeItem("instagram_info");
  // };
  // const facebookLogout = async () => {
  //   dispatch(facebookSignout());
  //   setFacebookState(null);
  // };
  useEffect(() => {
    // if (localStorage.getItem("instagram_info")) {
    //   setInstagram(JSON.parse(localStorage.getItem("instagram_info")));
    // }
    if (localStorage.getItem("wordpress_info")) {
      setWordpress(JSON.parse(localStorage.getItem("wordpress_info")));
    }
  }, []);

  // useEffect(() => {
  //   if (ls.get("facebook")) {
  //     setFacebookState(ls.get("facebook"));
  //   }
  // }, [facebook]);

  useEffect(() => {
    if (localStorage.getItem("twitter_username")) {
      setTwitterUserName(localStorage.getItem("twitter_username"));
    }
  }, [twitter]);

  // useEffect(() => {
  //   let user_info = {
  //     deso_id: deso?.user?.publicKeyAdded,
  //   };
  //   console.log("twitter", twitter?.user);
  //   if (twitter) {
  //     user_info.twitter_id = twitter?.user?.id;
  //   }
  //   if (deso?.user) {
  //     localStorage.setItem("user_info", JSON.stringify(user_info));
  //   }
  // }, [deso?.user]);

  let loginCard1 = [
    {
      title: "Twitter",
      link: "/twitter",
      icon: TwitterIcon,
      login: twitter?.user ? true : false,
      onPress: () => twitterLoginAction(),
      name: twitterUserName,
      photo: twitter?.user?.photoURL,
      signout: () => dispatch(twitterSignOut()),
    },
    // {
    //   title: "Tik Tok",
    //   link: "/tiktok",
    //   icon: TiktokIcon,
    // },
  ];
  let loginCard2 = [
    {
      title: "Wordpress",
      link: "/wordpress",
      icon: WordPressIcon,
      onPress: () => wordpressLogin(),
      login: wordpress?.display_name ? true : false,
      name: wordpress?.display_name,
      photo: wordpress?.profile_image_url,
      signout: () => wordpressLogout(),
    },
    // {
    //   title: "Instagram",
    //   link: "/instagram",
    //   icon: InstaragramIcon,
    //   onPress: () => instagramLogin(),
    //   login: instagram ? true : false,
    //   name: instagram?.display_name,
    //   photo: userIcon,
    //   signout: () => instagramLogout(),
    // },
    // {
    //   title: "Facebook",
    //   link: "/facebook",
    //   icon: FacebookIcon,
    //   onPress: () => facebookLoginAction(),
    //   login: facebookState ? true : false,
    //   name: facebookState?.displayName,
    //   photo: facebookState?.photoURL,
    //   signout: () => facebookLogout(),
    // },
  ];

  useEffect(() => {
    if (localStorage.getItem("credential")) {
    } else {
      window.location.pathname = "/";
    }
  }, [localStorage.getItem("credential")]);

  return twitter.loading && facebook?.loading ? (
    <Spinner />
  ) : (
    <section className="container mx-auto py-4 px-4 sm:px-4 md:px-12 mb-[350px]">
      <Iframe />
      <StepComponents />
      <Helmet>
        <title>Setu - Connect Social Media</title>
        <meta
          name="description"
          content="Log into DeSo and move your content to Web 3.0 with Setu for free. Publish your content securely, earn more, own your content, and expand your brand."
        />
      </Helmet>
      <div className="text-center">
        <h1 className="Secondheading font-bold">Connect your Social Media</h1>
        <p
          className={`text-[#161616] mt-[16px] text-[14px] md:text-[16px] max-w-[425px] w-[100%] mx-auto`}
        >
          Connect your web2 to Decentralised Social Media. You have full
          control, all we do is push your content to DeSo
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-4 mt-8 md:w-[700px] mx-auto">
        <div>
          {loginCard1.map((item, index) => (
            <DashboardCard key={index} item={item} />
          ))}
        </div>
        <div>
          {loginCard2.map((item, index) => (
            <DashboardCard key={index} item={item} />
          ))}
        </div>
      </div>
      <div className="md:w-[700px] mx-auto ">
        <p className="text-[18px] text-black">Coming Soon</p>
        <div className="mt-[8px] flex items-center">
          <img className="w-[40px]" src={InstaragramIcon} alt="" />
          <img className="w-[40px] mx-[8px]" src={LinkdeinIcon} alt="" />
        </div>
      </div>
    </section>
  );
}
